import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { CreateOverlayBody, OverlayUploadUrlData } from '../types';

export function useCreateOverlay() {
  const {
    data: uploadUrlData,
    isFetching,
    refetch: refetchUploadUrl,
  } = useApiQuery<OverlayUploadUrlData>('/overlays/upload-url', {
    queryKey: ['overlayUploadUrl'],
    initialData: null,
  });

  const createOverlayMutation = useApiMutation<CreateOverlayBody>(
    '/overlays',
    {
      method: 'POST',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    isFetching,
    uploadUrlData,
    refetchUploadUrl,
    createOverlayMutation,
  } as const;
}
